import { render, staticRenderFns } from "./SurveyFormDialog.vue?vue&type=template&id=36c81357&scoped=true&"
import script from "./SurveyFormDialog.vue?vue&type=script&lang=ts&"
export * from "./SurveyFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c81357",
  null
  
)

export default component.exports